import React from "react";

function AssessmentInstructions({ setSelfAssesmentStart, setOpenTimerIsUp }) {
  const instructions = [
    {
      desc: "The intention of this Self Assessment Guide is for you to check your own knowledge, skills, experience and current evidence you have so that you can determine what course or qualification would best apply to you. You can email this to us along with your enquiry and we can assist you in further determining if the course you have chosen is best for you, as well as the best / preferred pathway that suits your needs / work / life balance.",
    },
    {
      desc: "Do not print this Self Assessment Guide until after you have completed it electronically. You must complete this form electronically in order to calculate the outcome at the end of the form.",
    },
    {
      desc: "Choose one either Column A, B, C or D (once only per row), based on your evaluation for the Subject Area and Description. If you are unsure, simply choose Column A.",
    },
    {
      desc: "Spend no more than 30 minutes on this - your first instinct is usually correct!",
    },
  ];

  const handleStartSelfAssessment = () => {
    setOpenTimerIsUp(false);
    setSelfAssesmentStart(true);
  };

  return (
    <div className="bg-gray-100 rounded-lg mx-4 px-6 py-4 md:px-10 md:py-8 space-y-4 sm:space-y-6">
      <p className="uppercase text-lg sm:text-xl xl:text-2xl xl:text-2xl mb-2 md:mb-4 font-bold">
        Instructions for using this Self Assessment Guide
      </p>
      <div className="space-y-4">
        <ol className="list-decimal space-y-6 ml-3 text-justify text-sm sm:text-base xl:text-xl">
          {instructions.map((instruction, i) => {
            return <li key={i}>{instruction.desc}</li>;
          })}
        </ol>
      </div>
      <button
        className="uppercase tracking-widest bg-black text-white w-full p-2 rounded-xl text-lg sm:text-xl xl:text-2xl xl:text-2xl font-semibold disabled:opacity-30"
        onClick={() => handleStartSelfAssessment()}
      >
        Start Evaluation
      </button>
    </div>
  );
}

export default AssessmentInstructions;
